// extracted by mini-css-extract-plugin
export default {"wrapper":"CenterLayout_wrapper__FarsX","inner":"CenterLayout_inner__OVLMF"};